module.exports = (
  $scope,
  $state,
  $stateParams,
  viewExports,
  User
) ->

  $scope.user = User
  $scope.exports = viewExports.exports
  $scope.subject = viewExports.subject
  $scope.entityNames = viewExports.entity_names.join(", ")
  $scope.totalExports = viewExports.exports.length
  $scope.currentPage = 0
  $scope.max = viewExports.exports.length
